import { useIntl } from "react-intl";
import { AppState } from '@nxsys/store';
import { useSelector } from 'react-redux';
import AppsContainer from "@nxsys/components/AppsContainer";
import KIDList from "./KIDList";

const KIDListingScreen = () => {
  const { loading } = useSelector((state: AppState) => state.kid);
  const { messages } = useIntl();

  return (
    <AppsContainer
      fullView
      title={messages["kid.listing"] as string}
      type="bottom"
      loading={loading}
    >
      <KIDList />
    </AppsContainer>
  );
};

export default KIDListingScreen;
